import { Link } from "react-router-dom";
import { Activity } from "lucide-react";

const IMG = "https://images.pexels.com/photos/32115905/pexels-photo-32115905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="flex flex-col justify-center px-6 py-12 sm:px-16">
        <Link to="/" className="mb-12 flex items-center gap-2" data-testid="auth-home-link">
          <span className="grid h-9 w-9 place-items-center rounded-xl bg-teal-700 text-white"><Activity className="h-4 w-4" /></span>
          <span className="font-display text-xl font-semibold">Klinic</span>
        </Link>
        <div className="w-full max-w-md rise">
          <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">{title}</h1>
          <p className="mt-2 text-sm text-slate-500">{subtitle}</p>
          <div className="mt-8">{children}</div>
        </div>
      </div>
      <div className="relative hidden lg:block">
        <img src={IMG} alt="Doctor" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 to-transparent" />
        <p className="absolute bottom-12 left-12 max-w-sm font-display text-2xl text-white">Clinical care in front. Clean books behind.</p>
      </div>
    </div>
  );
}
